// @ts-nocheck
import Vue from 'vue';
import App from './App.vue';
import router from './router/router';
import Vant from 'vant';
import { Dialog } from 'vant';
import 'vant/lib/index.css';
import '@/assets/css/app.css';
import global from './core/global/global';
import appJs from './assets/js/app.js';
import wxService from '@/core/wxTs/wxService';
import api from './core/net/default.interceptor';
import loading from './core/net/loading';
import device2 from '@/assets/js/device2'
import axios from 'axios';
import device from '@/core/net/device';
import config from '@/core/net/config';


// 神策埋点--------start--------
// 使用sensor1.22.6埋点 老的废弃
import autotrack from '@/assets/js/autotrack-1.22.6.js';
import trackFn from '@/assets/js/trackFn-1.22.6.js';
import querystring from 'querystring';
import uniondrug from  'uniondrug';

autotrack.autoTfn();
Vue.prototype.$trackFn = trackFn
const {platform} = querystring.parse(location.search.replace('?', ''));
trackFn.setTrackData({platform});
trackFn.clearAllRegister();
trackFn.logout();
trackFn.setPublicData({
    platform_name: platform === 'nice_drug' ? 'gouyaopingtai' : 'qita',//平台名称-yaodianbao,gouyaopingtai,qita
    is_login: false,
    business_line_id: platform === 'nice_drug' ? platform : 'qita',//业务线id-nice_drug,qita
})
// 神策埋点--------end--------

Vue.use(Vant);
// rem
appJs.app();
// initFontSize
wxService.initFontSize();

//百度统计埋点
var _hmt = _hmt || [];
(window as any)._hmt = _hmt
if (location.host.indexOf('turboradio.cn') > -1) {
    (function () {
        var hm = document.createElement('script');
        hm.src = 'https://hm.baidu.com/hm.js?63ca767017146dfc3ce5b912dc927e97';
        let s:any = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(hm, s);
    })();
}
if (location.host.indexOf('uniondrug.cn') > -1) {
    (function () {
        var hm = document.createElement('script');
        hm.src = 'https://hm.baidu.com/hm.js?3f54d3cf7f662ff4a64710993bccae01';
        let s:any = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(hm, s);
    })();
}


// 授权
router.beforeEach((to, from, next) => {
    // deviceFn();

    // function deviceFn() {
    //     let fromUrl = document.referrer;
    //     if (from.path !== '/') {
    //         fromUrl = window.location.protocol + '//' + window.location.host + from.fullPath
    //     }
    //     //页面埋点
    //     let exdata = device2.anchor(fromUrl, window.location.protocol + '//' + window.location.host + to.fullPath)
    //     axios.defaults.headers.common.exdata = JSON.stringify(exdata);
    //     axios.post(process.env.VUE_APP_device, {})
    // }
     // 埋点全局变量
    //  Vue.prototype.$deviceFn = device.deviceFn;

    if ((window as any)._hmt) {
        if (to.path) {
            (window as any)._hmt.push(['_trackPageview', '/#' + to.fullPath])
        }
    }

    console.log(to.fullPath)
    sessionStorage.setItem('referer', to.fullPath)
    // 配置标题
    let mainOrderNo = to.query.mainOrderNo;
    let orderNo = to.query.orderNo;
    document.title = to.meta.title ? to.meta.title : '医患服务平台';

    if (from.path == '/success') {
        next(false)
    } else {
        next();
    }

});

// 全局变量定义
global.global();

Vue.config.productionTip = false;

// api.get('https://httpbin.org/ip',).then((res:any) => {
//     sessionStorage.setItem('ip', res.origin)
// })


/* eslint-disable no-new */
new Vue({
    router,
    render: (h) => h(App),
}).$mount('#app');
